import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import { CModal } from '@coreui/react';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import JsonToExcelDownloader from '../../components/JsonToExcelDownloader';
import { GeneratePdf } from '../../components/GeneratePdf';
import separator_line from "../../assets/separator_line.png";
import { getCurrentTime } from '../../components/CurrentTime';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { ErrorMessage } from '../../validation/validationError';
import { ZodError } from 'zod';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { sectionStudentAttendanceFormValidation } from '../../validation/Validation';
import moment from 'moment';
import { Loader } from '../../components/ModalsCommonFunctions';

const SectionStudentAttendance = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        instituteGradeMasterId: '',
        instituteDivisionMasterId: '',
        month: ''
    }
    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [errors, setErrors] = useState([]);
    const [attendanceData, setAttendanceData] = useState(initialFormState);
    const [attendanceList, setAttendanceList] = useState([]);
    const [dateHeaders, setDateHeaders] = useState([])
    const [reportData, setReportData] = useState({});
    const [editId, setEditId] = useState(null)

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGradeList()
    }, []);

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;

        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleGradeChange = (e) => {
        const { name, value } = e.target;
        setAttendanceData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                instituteDivisionMasterId: ''
            }
        })
        setAttendanceList([]);

        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });

        if (value.trim().length !== 0) {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const handleMonth = (newMonth) => {
        setAttendanceData((prevData) => ({
            ...prevData,
            month: newMonth ? newMonth.format('YYYY-MM') : '',
        }));

        if (newMonth && newMonth.format('YYYY-MM').trim().length !== 0) {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== 'month'));
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAttendanceData((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })

        if (value.trim().length !== 0) {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const showReport = async () => {
        try {
            await sectionStudentAttendanceFormValidation.parseAsync(attendanceData);

            setLoading(true);
            setAttendanceList([]);
            let apiUrl = `/get-student-monthly-attendance-report?month=${attendanceData.month.split("-")[1]}&year=${attendanceData.month.split("-")[0]}&instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&instituteGradeMasterId=${attendanceData.instituteGradeMasterId}&instituteDivisionMasterId=${attendanceData.instituteDivisionMasterId}`;
            authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
                .then(response => {
                    const firstStudent = response.data.data[0];
                    const maxDay = Math.max(...Object.keys(firstStudent).filter(key => !isNaN(key)).map(Number));
                    setDateHeaders(Array.from({ length: maxDay }, (_, i) => i + 1));

                    const totalDays = response.data.data.map(student => {
                        let presentDays = 0;
                        let absentDays = 0;
                        let holiDays = 0;

                        // Count 'P' and 'A' occurrences within the available days
                        for (let day = 1; day <= maxDay; day++) {
                            const status = student[day];
                            if (status === 'P') presentDays += 1;
                            if (status === 'A') absentDays += 1;
                            if (status === "HD") holiDays += 1;
                        }

                        // Add the counts to the student object
                        return {
                            ...student,
                            holiDays,
                            presentDays,
                            absentDays
                        };
                    });

                    setAttendanceList(totalDays);
                    setReportData({
                        divisionData: response.data.divisionData,
                        gradeData: response.data.gradeData,
                        instituteData: response.data.instituteData,
                        sectionData: response.data.sectionData,
                        teacherData: response.data.teacherData,
                        month: response.data.month,
                        year: response.data.year
                    })

                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } catch (error) {
            if (error instanceof ZodError) {
                setErrors(error.errors)
            }
        }
    }

    const handleInputReset = () => {
        setEditId('');
        setAttendanceData(initialFormState);
        setAttendanceList([]);
        setErrors([]);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Student Attendance</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-user-check"></i>Student Attendance</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="instituteGradeMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={handleGradeChange} value={attendanceData.instituteGradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errors} field="instituteGradeMasterId" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="instituteDivisionMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteDivisionMasterId' onChange={handleInputChange} value={attendanceData.instituteDivisionMasterId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errors} field="instituteDivisionMasterId" />
                                                </div>

                                                <div className="col-md-6 full_wrap">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Month</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={['year', 'month']}
                                                            value={dayjs(attendanceData.month)}
                                                            onChange={handleMonth}
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                    <ErrorMessage errors={errors} field="month" />
                                                </div>

                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary " style={{ marginRight: '20px' }} type="button" onClick={showReport}>Show</button>
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="separator"></div>
                                                {attendanceList.length > 0 ? (
                                                    <>
                                                        <GeneratePdf id="studentAttendance" />
                                                        <div className="d-grid gap-2 mt-2">
                                                            <div class="report_block landscape" id='studentAttendance'>
                                                                <div class="heading">
                                                                    <div class="logo">
                                                                        <img src={reportData?.sectionData?.logoPath} alt="" />
                                                                    </div>
                                                                    <div class="text_center">
                                                                        <h6>{reportData?.instituteData?.instituteName}</h6>
                                                                        <h4>{reportData?.sectionData?.sectionName}</h4>
                                                                    </div>
                                                                    <div class="logo">
                                                                        <img src={reportData?.instituteData?.logoPath} alt="" />
                                                                    </div>
                                                                </div>
                                                                <div class="report_code text_center">
                                                                    <img src={separator_line} alt="" className="line" />
                                                                    <span className="txt">Monthly Student Attendance Report</span>
                                                                </div>

                                                                <div class="report_head">
                                                                    <span>Teacher Name: {reportData?.teacherData?.teacherName}</span>
                                                                    <span>Class: {reportData?.gradeData?.gradeName}</span>
                                                                    <span>Division: {reportData?.divisionData?.divisionName}</span>
                                                                    <span>Date: {moment(`${reportData.year}-${reportData.month}-01`).format('MMM-YYYY')}</span>
                                                                </div>

                                                                <div class="analysis_report">
                                                                    {/* <span class="table_caption">Attendance Details</span> */}
                                                                    <table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th rowSpan="2">Sr. No.</th>
                                                                                <th rowSpan="2">Roll No</th>
                                                                                <th rowSpan="2">Reg No</th>
                                                                                <th rowSpan="2">Student Name</th>
                                                                                {dateHeaders.map(date => (
                                                                                    <th rowSpan="2" key={date}>{date}</th>
                                                                                ))}
                                                                                <th colSpan="3">Total</th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th>Working Days</th>
                                                                                <th>Absent Days</th>
                                                                                <th>Present Days</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                attendanceList.map((student, index) => (
                                                                                    <>
                                                                                        <tr>
                                                                                            <td>{student.SrNo}</td>
                                                                                            <td>{student.RollNo}</td>
                                                                                            <td>{student.RegNo}</td>
                                                                                            <td>{student.StudentName}</td>
                                                                                            {dateHeaders.map(date => (
                                                                                                <td key={date}>{student[date.toString()]}</td>
                                                                                            ))}
                                                                                            <td>{(dateHeaders.length - student.holiDays)}</td>
                                                                                            <td>{student.absentDays}</td>
                                                                                            <td>{student.presentDays}</td>
                                                                                        </tr>
                                                                                    </>
                                                                                ))
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                                <div class="report_footer">
                                                                    <div class="section_incharge">
                                                                        <span>{reportData?.sectionData?.sectionInchargeName}</span>
                                                                        <span>Section Incharge Name</span>
                                                                    </div>
                                                                    <div class="institute_head">
                                                                        <span>{reportData?.instituteData?.inchargeName}</span>
                                                                        <span>Institute Head Name</span>
                                                                    </div>
                                                                    <div class="timestamp">
                                                                        <span>{getCurrentTime()}</span>
                                                                        <span>Time stamp of export</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="text-center" style={{ padding: "50px", fontWeight: 'bold' }}>
                                                        No Report Available
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionStudentAttendance;